import { useLanguage } from '@/contexts/LanguageContext';
import { Globe } from 'lucide-react';

export const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <button
      onClick={() => setLanguage(language === 'en' ? 'id' : 'en')}
      className="flex items-center gap-1.5 text-muted-foreground hover:text-foreground transition-colors px-2 py-1 rounded-lg"
    >
      <Globe className="h-4 w-4" />
      <span className="text-sm font-medium">{language === 'en' ? 'EN' : 'ID'}</span>
    </button>
  );
};
